/**
 * DeviceInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DeviceInfo
 */
export interface DeviceInfo {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 应用发布平台（构建产物类型）（可选值：ios=iOS App; android=Android App; web=Web 应用） */
  platform?: string
  /** 设备名称（如 iPhone 15 Pro） */
  name?: string
  /** 设备型号（如 iPhone16,1） */
  model?: string
  /** 系统版本（如 18.1） */
  os_version?: string
  /** 客户端版本（如 1.2.0） */
  app_version?: string
  /** 构建号（如 100） */
  app_build?: string
  /** 推送令牌（APNs/FCM） */
  push_token?: string
  /** 语言区域（如 zh-CN） */
  locale?: string
  /** 时区（如 Asia/Shanghai） */
  timezone?: string
  /** 最后登录IP */
  last_ip?: string
  /** 屏幕宽度（像素） */
  screen_width?: number
  /** 屏幕高度（像素） */
  screen_height?: number
  /** 屏幕缩放比例（如 2.0、3.0） */
  screen_scale?: number
  /** 最后活跃时间（UTC） */
  last_active_at?: string
  /** 设备操作系统（可选值：ios=iOS; android=Android; macos=macOS; windows=Windows; linux=Linux; harmonyos=HarmonyOS; unknown=未知） */
  os?: string
  /** 设备品牌（如 Apple） */
  brand?: string
  /** 设备类型（可选值：phone=手机; tablet=平板; desktop=桌面; watch=手表; tv=电视; unknown=未知） */
  type?: string
}

/**
 * DeviceInfo Schema
 */
export const DeviceInfoSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    platform: {
      description:
        '应用发布平台（构建产物类型）（可选值：ios=iOS App; android=Android App; web=Web 应用）',
      format: 'cons.AppPlatform',
      type: 'string',
      label: '应用发布平台',
    },
    name: {
      description: '设备名称（如 iPhone 15 Pro）',
      format: 'string',
      type: 'string',
      label: '设备名称',
    },
    model: {
      description: '设备型号（如 iPhone16,1）',
      format: 'string',
      type: 'string',
      label: '设备型号',
    },
    os_version: {
      description: '系统版本（如 18.1）',
      format: 'string',
      type: 'string',
      label: '系统版本',
    },
    app_version: {
      description: '客户端版本（如 1.2.0）',
      format: 'string',
      type: 'string',
      label: '客户端版本',
    },
    app_build: {
      description: '构建号（如 100）',
      format: 'string',
      type: 'string',
      label: '构建号',
    },
    push_token: {
      description: '推送令牌（APNs/FCM）',
      format: 'string',
      type: 'string',
      label: '推送令牌',
    },
    locale: {
      description: '语言区域（如 zh-CN）',
      format: 'string',
      type: 'string',
      label: '语言区域',
    },
    timezone: {
      description: '时区（如 Asia/Shanghai）',
      format: 'string',
      type: 'string',
      label: '时区',
    },
    last_ip: {
      description: '最后登录IP',
      format: 'string',
      type: 'string',
      label: '最后登录IP',
    },
    screen_width: {
      description: '屏幕宽度（像素）',
      format: 'int',
      type: 'integer',
      label: '屏幕宽度',
    },
    screen_height: {
      description: '屏幕高度（像素）',
      format: 'int',
      type: 'integer',
      label: '屏幕高度',
    },
    screen_scale: {
      description: '屏幕缩放比例（如 2.0、3.0）',
      format: 'float64',
      type: 'number',
      label: '屏幕缩放比例',
    },
    last_active_at: {
      description: '最后活跃时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '最后活跃时间',
    },
    os: {
      description:
        '设备操作系统（可选值：ios=iOS; android=Android; macos=macOS; windows=Windows; linux=Linux; harmonyos=HarmonyOS; unknown=未知）',
      format: 'cons.DeviceOs',
      type: 'string',
      label: '设备操作系统',
    },
    brand: {
      description: '设备品牌（如 Apple）',
      format: 'string',
      type: 'string',
      label: '设备品牌',
    },
    type: {
      description:
        '设备类型（可选值：phone=手机; tablet=平板; desktop=桌面; watch=手表; tv=电视; unknown=未知）',
      format: 'cons.DeviceType',
      type: 'string',
      label: '设备类型',
    },
  },
  type: 'object',
}
